<!-- eslint-disable no-unused-vars -->
<template>
  <div
    class="relative w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg cursor-pointer"
    @click="viewSession(session.id)"
  >
    <img
      v-if="session && session.image"
      :src="session.image"
      :alt="session.title || 'Session thumbnail'"
      class="absolute inset-0 w-full h-full object-cover"
      @error="onImageError"
    >

    <div
      v-else
      class="absolute inset-0 w-full h-full object-cover bg-gray-300 grid place-items-center text-gray-600 text-sm p-4 text-center"
    >
      No Image Available
    </div>

    <div
      class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"
    />

    <div class="absolute inset-0 p-3 flex flex-col justify-end text-white">
      <div
        class="absolute top-3 left-3 flex items-center bg-black/50 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-medium"
      >
        <i class="fas fa-user-friends mr-1" />
        <span>{{ session?.attendees ?? 0 }}</span>
      </div>

      <div>
        <p class="text-base font-bold leading-tight mb-1">
          {{ session?.title || "Untitled Session" }}
        </p>

        <p class="text-xs font-medium opacity-80">
          {{ session?.host || "Unknown Host" }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

const props = defineProps({
  session: {
    type: Object,
    required: true, 
  },
  isLive: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();

console.log("SessionCard props:", props);
console.log("SessionCard router:", router);


function onImageError(e) {
  e.target.src = "https://via.placeholder.com/600x800/293b5a/FFFFFF?text=Error"; 
}

function viewSession(sessionId) {
  console.log("Navigating to session:", sessionId);
}
</script>